import { Button, Form, FormikField } from '@ahmdigital/ui';
import { Formik, FormikValues } from 'formik';
import { upperFirst } from 'lodash/fp';

import { Customer } from '../../../../../../selectors/select-customer/types';
import constants from '../../../../../../ahm-constants';
import getFrequencyOptions from '../../../../../../utils/get-frequency-options';
import getScaleOptions from '../../../../../../utils/get-scale-options';

export type BasicDetailsModalFormValues = {
  frequency?: Customer['frequency'];
  scale?: Customer['scale'];
  state?: Customer['state'];
};

export type BasicDetailsFormProps = {
  defaultValues?: BasicDetailsModalFormValues;
  handleSubmit: (values: BasicDetailsModalFormValues) => void;
};

const BasicDetailsForm = ({ defaultValues, handleSubmit }: BasicDetailsFormProps) => {
  const frequencyOptions = getFrequencyOptions({ endText: 'ly', format: upperFirst });
  const scaleOptions = getScaleOptions({});

  return (
    <Formik initialValues={defaultValues as FormikValues} onSubmit={handleSubmit}>
      {(formik) => (
        // @ts-expect-error - Automatic, Please fix when editing this file
        <Form onSubmit={formik.onSubmit}>
          <FormikField
            label="Cover type"
            name="scale"
            options={scaleOptions}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            type="dropdown"
          />
          <FormikField
            label="Living in"
            name="state"
            options={constants.STATE_OPTIONS}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            type="dropdown"
          />
          <FormikField
            label="Paying"
            name="frequency"
            options={frequencyOptions}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            type="dropdown"
          />
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: string; variant: string; type: string; onClick: (e?: FormEvent<HTMLFormElement> | undefined) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<ButtonProps, keyof ButtonProps> & Pick<InferProps<{ variant: Requireable<NonNullable<string | object | null | undefined>>; analytics: Requireable<...>; }>, "analytics"> & Pick<...>, "icon" | "analytics"> & Partial<...> & Partial<...>'. */}
          <Button variant="wide" type="submit" onClick={formik.handleSubmit}>
            Choose my cover
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default BasicDetailsForm;
